import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { Label } from '../components/ui/label';
import Footer from '../components/Footer';
import Nav from '../components/Nav';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Contact = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setError('');

    try {
      const response = await axios.post(`${API}/contact`, formData);
      if (response.data.success) {
        setSubmitted(true);
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setSubmitted(false), 5000);
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Something went wrong. Please try again.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Nav />

      <div className="max-w-2xl mx-auto px-4 sm:px-6 py-14 sm:py-20 flex-1 w-full">
        <h1
          className="text-3xl sm:text-4xl lg:text-5xl font-normal mb-10 sm:mb-12 text-center leading-tight"
          style={{ fontFamily: 'Instrument Serif, serif' }}
        >
          Get in touch
        </h1>

        {submitted ? (
          <div
            data-testid="contact-success-message"
            className="bg-[#0a5c44] text-white px-6 py-5 sm:px-8 sm:py-6 rounded-xl text-center mb-8"
          >
            <p className="text-base sm:text-lg font-medium">
              Thank you for reaching out. We'll get back to you soon.
            </p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-5 sm:space-y-6 mb-12">
            {error && (
              <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <div>
              <Label htmlFor="name" className="text-base font-normal text-[#1a1a1a] mb-2 block">
                Name
              </Label>
              <Input
                id="name"
                data-testid="contact-name-input"
                type="text"
                value={formData.name}
                onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                className="bg-white border-[#e0ddd8] h-11"
                required
              />
            </div>

            <div>
              <Label htmlFor="email" className="text-base font-normal text-[#1a1a1a] mb-2 block">
                Work email
              </Label>
              <Input
                id="email"
                data-testid="contact-email-input"
                type="email"
                value={formData.email}
                onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                className="bg-white border-[#e0ddd8] h-11"
                required
              />
            </div>

            <div>
              <Label htmlFor="message" className="text-base font-normal text-[#1a1a1a] mb-2 block">
                Message
              </Label>
              <Textarea
                id="message"
                data-testid="contact-message-input"
                value={formData.message}
                onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                className="bg-white border-[#e0ddd8] min-h-[150px]"
                required
              />
            </div>

            <Button
              type="submit"
              data-testid="contact-submit-button"
              disabled={isSubmitting}
              className="w-full bg-[#1a1a1a] text-white hover:bg-[#2a2a2a] transition-colors h-12 text-base"
            >
              {isSubmitting ? 'Sending...' : 'Send'}
            </Button>
          </form>
        )}

        <div className="text-center">
          <p className="text-sm sm:text-base text-[#1a1a1a]/60">
            Or email us directly at{' '}
            <a href="mailto:hello@verilock.ai" className="text-[#0a5c44] hover:underline">
              hello@verilock.ai
            </a>
          </p>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Contact;
